import { message } from "antd";
import { useCallback, useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { getOrganizationById } from "./api/organizations";
import { PaymentTypeRecord } from "./types";

export function usePaymentsTypes() {
  const [searchParams] = useSearchParams();
  const [paymentTypes, setPaymentTypes] = useState<PaymentTypeRecord[]>([]);

  const orgId = searchParams.get("orgId");

  const fetchPaymentTypes = useCallback(async () => {
    if (!orgId) return;

    try {
      const response = await getOrganizationById(orgId, {
        params: { filterkeys: "masterPaymentTypes" },
      });

      if (!response?.success) {
        message.error(response?.message ?? "Failed to fetch payment types");
        return;
      }

      const masterPaymentTypes = response?.result?.masterPaymentTypes;

      if (!masterPaymentTypes || !Array.isArray(masterPaymentTypes)) {
        setPaymentTypes([]);
        return;
      }

      const formatted = masterPaymentTypes.map((payment) => ({
        uid: crypto.randomUUID(),
        ...payment,
        propertyLabels: payment?.propertyLabels,
      }));

      setPaymentTypes(formatted);
    } catch (error) {
      message.error("Something went wrong while fetching payment types");
    }
  }, [orgId]);

  useEffect(() => {
    if (!orgId) {
      setPaymentTypes([]);
      return;
    }

    fetchPaymentTypes();
  }, [orgId, fetchPaymentTypes]);

  return {
    paymentTypes,
    refetchPaymentTypes: fetchPaymentTypes,
  };
}
